module.exports = "/packs/about-mokumoku-section-image-e4749bcee752d403329936b0425d1295.png";